import { render, staticRenderFns } from "./FinalQuizAvailable.vue?vue&type=template&id=2bba3b2a&scoped=true&"
import script from "./FinalQuizAvailable.vue?vue&type=script&lang=js&"
export * from "./FinalQuizAvailable.vue?vue&type=script&lang=js&"
import style0 from "./FinalQuizAvailable.vue?vue&type=style&index=0&id=2bba3b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bba3b2a",
  null
  
)

export default component.exports